import { showModal, hideModal } from 'src/slices/modal';
import { useDispatch } from 'react-redux';

const useModal = (value) => {
  const dispatch = useDispatch();

  const show = ({ onClose, ...props } = {}) => {
    const valueProp = props.type ?? value;
    return dispatch(
      showModal({
        type: valueProp,
        modal: typeof valueProp === 'string' ? null : value,
        props: {
          isOpen: true,
          onClose: (needReload = false) => {
            if (onClose) {
              onClose(needReload);
            }
            dispatch(hideModal());
          },
          ...props ?? {},
        },
      }),
    );
  };

  return { show, hide: () => dispatch(hideModal()) };
};

export default useModal;
